module.exports = __webpack_public_path__ + "static/certificate1-29c3f0164879607a8fa03da5f5f97abc.pdf";